<template>
    <v-card flat>
        <v-card-title>
            <div class="font-size-16 font-weight-600">
                Detail Soal Bundle Subtes
            </div>
            <v-spacer />

            <v-btn icon @click="$emit('close')">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-card-title>

        <v-card-text class="pt-3">
            <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                placeholder="Masukan kata kunci pencarian"
                dense
                outlined
                class="mb-3"
                hide-details
            ></v-text-field>

            <v-data-table
                :headers="headers"
                :items="bundles"
                :search="search"
                :loading="loading"
            >
                <template v-slot:item.soal="{ item }">
                    <div class="py-5" v-html="parseLatex(item.soal)"></div>
                </template>

                <template v-slot:no-results>
                    <div class="text-center">
                        <p class="my-2">Hasil pencarian tidak ditemukan.</p>
                    </div>
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
</template>

<script>
import firebase from "firebase";
import katex from "katex";
import showdown from "showdown";

export default {
    props: {
        bundleCode: { required: true, type: String },
    },

    data() {
        return {
            loading: false,
            search: null,
            headers: [
                { text: "No.", value: "sequence" },
                { text: "Soal", value: "soal", width: "50%" },
                { text: "Kode Soal", value: "item_code" },
                { text: "Tipe Pilihan", value: "tipe_pilihan" },
            ],
            bundles: [],
        };
    },

    mounted() {
        this.getDetailBundles();
    },

    methods: {
        async getDetailBundles() {
            this.loading = true;

            try {
                const docRef = firebase
                    .firestore()
                    .collection("ambis_test_question")
                    .doc(this.bundleCode)
                    .collection(`${this.bundleCode}_00001`)
                    .doc("question");

                const doc = await docRef.get();

                if (doc.exists) {
                    var data = doc.data().body;
                    data = JSON.parse(data);
                    this.bundles = data.items || [];
                }
            } catch (error) {
                console.log(error);
            } finally {
                this.loading = false;
            }
        },

        parseLatex: function (content) {
            var converter = new showdown.Converter();

            var compiledContent = content.replace(/&gt;/g, ">");
            compiledContent = compiledContent.replace(/&lt;/g, "<");
            compiledContent = compiledContent.replace(/&amp;/g, "&");

            compiledContent = this.compileInlineLatex(compiledContent);
            compiledContent = this.compileBlockLatex(compiledContent);

            return converter.makeHtml(compiledContent);
        },

        compileInlineLatex: function (content) {
            var pattern = /\\\\\((.*?)\\\\\)/g;
            var compiledContent = content;
            var match;

            // eslint-disable-next-line
            while ((match = pattern.exec(compiledContent))) {
                var index = match.index;
                var length = match[0].length;
                var formula = katex.renderToString(match[1], { trust: true });
                compiledContent =
                    compiledContent.substr(0, index) +
                    formula +
                    compiledContent.substr(index + length);
            }

            return compiledContent;
        },

        compileBlockLatex: function (content) {
            var pattern = /\$\$(.*?)\$\$/g;
            var compiledContent = content;
            var match;

            // eslint-disable-next-line
            while ((match = pattern.exec(compiledContent))) {
                var index = match.index;
                var length = match[0].length;
                var formula =
                    '<p class="text-center">' +
                    katex.renderToString(match[1], { trust: true }) +
                    "</p>";
                compiledContent =
                    compiledContent.substr(0, index) +
                    formula +
                    compiledContent.substr(index + length);
            }
            return compiledContent;
        },
    },
};
</script>



// WEBPACK FOOTER //
// DialogDetailBundle.vue?5419afc8